"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Description = exports.InputSlider = exports.Container = exports.SliderProgress = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _typography = require("@creditas-lab/typography");

var _inputSlider = require("@creditas-lab/input-slider");

var _styledTools = require("styled-tools");

const sliderProgress = props => (0, _stylitas.css)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  height: 100%;
  width: ${(0, _styledTools.prop)('progress.mobile')(props)};
  min-width: 43px;
  background: ${(0, _styledTools.theme)('colorBrandPrimaryLight')(props)};

  ${_styleUtilities.media.md`
    min-width: 75px;
    width: ${(0, _styledTools.prop)('progress.desktop')(props)};
  `}
`;

const SliderProgress = _stylitas.styled.div`
  ${sliderProgress};
`;
exports.SliderProgress = SliderProgress;
const Container = _stylitas.styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;
exports.Container = Container;
const InputSliderStyled = (0, _stylitas.styled)(_inputSlider.InputSlider)`
  margin-top: 40px;

  ${_styleUtilities.media.md`
    margin-top: 52px;
  `}
`;
exports.InputSlider = InputSliderStyled;
const Description = (0, _stylitas.styled)(_typography.Typography)`
  text-align: center;
  color: ${(0, _styledTools.theme)('colorFontNeutral60')};
`;
exports.Description = Description;